// Reconnaissance du donateur (décision d'Avi, 30/09/2026) : APRÈS le code,
// la fiche revient pré-remplie et le serveur dit ce qui y manque
// (``missing_fields`` de recognize-donor). Ce module transforme cette liste
// en phrases simples, communes aux pages campagne, don et fête.
//
// Sans code, le serveur ne renvoie que « email » / « téléphone » manquants
// (rien sur le nom ni l'adresse) : les pages n'affichent alors aucune alerte.

const ADRESSE = ["address", "postal_code", "city"];

// Libellés par défaut (français). La page de don, bilingue, passe les siens.
export const PHRASES_MANQUANTS = {
  nom: "Il manque votre nom pour le reçu fiscal.",
  adresse: "Il manque votre adresse pour le reçu fiscal.",
  email: "Votre email n'est pas enregistré : il sert à vous envoyer votre reçu fiscal.",
  telephone: "Votre téléphone n'est pas enregistré : l'ajouter permet de recevoir les rappels par SMS.",
};

/** Vrai si ``champ`` fait partie des champs manquants. */
export function estManquant(manquants, champ) {
  return Array.isArray(manquants) && manquants.includes(champ);
}

/** Vrai si une partie de l'adresse du reçu fiscal manque. */
export function adresseManquante(manquants) {
  return ADRESSE.some((c) => estManquant(manquants, c));
}

/**
 * Phrases à afficher, dans l'ordre d'importance pour le reçu fiscal.
 * Liste vide = rien ne manque.
 */
export function phrasesChampsManquants(manquants, libelles = PHRASES_MANQUANTS) {
  const l = { ...PHRASES_MANQUANTS, ...(libelles || {}) };
  const phrases = [];
  if (estManquant(manquants, "first_name") || estManquant(manquants, "last_name")) phrases.push(l.nom);
  if (adresseManquante(manquants)) phrases.push(l.adresse);
  if (estManquant(manquants, "email")) phrases.push(l.email);
  if (estManquant(manquants, "phone")) phrases.push(l.telephone);
  return phrases;
}
